import { render, staticRenderFns } from "./EmployeeEditTabIdentification.vue?vue&type=template&id=d160b6ae"
import script from "./EmployeeEditTabIdentification.vue?vue&type=script&lang=js"
export * from "./EmployeeEditTabIdentification.vue?vue&type=script&lang=js"
import style0 from "./EmployeeEditTabIdentification.vue?vue&type=style&index=0&id=d160b6ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports